

const _BASE_CLASS = "online-course-structure"

function CourseTopicList({
    selectedTopic,
    topics,
    onChageSelectedAssetPointer
}) {

    return <div
        className={`${_BASE_CLASS}__topics`}
    >

        {
            !topics.length ? "No sections added" :
                topics.map(topic => {
                    const isSelected = selectedTopic === topic._id;
                    return <div key={topic._id}
                        className={`${_BASE_CLASS}__topics-list-item`}
                        onClick={(e) => onChageSelectedAssetPointer(e, 'day', topic._id)}
                    >
                        <div className={`${_BASE_CLASS}__topics-list-item-title`}> 
                            {topic.title}
                        </div>
                    </div>
                })
        }
    </div>

}

function CourseModuleListItem({
    selectedTopic,
    module,
    topics,
    onAddTopic,
    onChageSelectedAssetPointer,
    isSelected
}) {

    const m = module;

    return <div
        className={`${_BASE_CLASS}__modules-list-item`}
        key={m._id} onClick={(e) => onChageSelectedAssetPointer(e, 'week', m._id)}
    >
        <div
            className={`${_BASE_CLASS}__modules-list-item-title`}
            style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}
        >
            <span>{m.title}</span>
            <span
                className={`${_BASE_CLASS}__modules-list-item-add-topic`}
                onClick={onAddTopic}
            >+</span>
        </div>
        {
            !isSelected ? null : (
                <CourseTopicList
                    onChageSelectedAssetPointer={onChageSelectedAssetPointer}
                    selectedTopic={selectedTopic}
                    topics={topics}
                />
            )
        }
    </div>
}


function CourseModuleList({
    selectedModule,
    selectedTopic,
    modules,
    topics,
    onAddTopic,
    onAddModule,
    onChageSelectedAssetPointer
}) {

    return <div
        className={`${_BASE_CLASS}__modules`}
    >
        <div
            className={`${_BASE_CLASS}__modules-section-title`}
        >
            <span>Modules</span>
            <span
                className={`${_BASE_CLASS}__modules-section-add-module`}
                onClick={onAddModule}
            >+</span>
        </div>
        {

            modules.map(m => {
                const isSelected = selectedModule === m._id;

                return <CourseModuleListItem key={m._id}
                    module={m}
                    onAddTopic={onAddTopic}
                    topics={topics}
                    onChageSelectedAssetPointer={onChageSelectedAssetPointer}
                    isSelected={isSelected}
                />
            })
        }
    </div>

}



const _OnlineCourseStrucureView = ({
    course, months, weeks, days, assets,
    selectedMonth, selectedWeek, selectedDay, selectedAsset,
    onPublishCourse,
    onChageSelectedAssetPointer,
    onChangeMonth, onChangeWeek, onChangeDay, onChangeAsset,
    onAddMonth, onAddWeek, onAddDay, onAddAsset,
    onDeleteAsset,
    ...props
}
) => {
    const partitions = months;
    const modules = weeks;
    const topics = days;
    const selectedPart = selectedMonth;
    const selectedModule = selectedWeek;
    const selectedTopic = selectedDay;

    return (
        <div className={`${_BASE_CLASS}`}>
            {
                !selectedPart ? <></> : (
                    <CourseModuleList
                        selectedModule={selectedModule}
                        selectedTopic={selectedTopic}
                        modules={modules}
                        topics={topics}
                        onAddModule={onAddWeek}
                        onAddTopic={onAddDay}
                        onChageSelectedAssetPointer={onChageSelectedAssetPointer}
                    />
                )
            }
        </div>
    )

}

export const OnlineCourseStrucureView = _OnlineCourseStrucureView;
